import { TypedFormattedMessageFactory, useTypedIntlFactory } from 'locale/typedIntl';
import { Language } from 'shared/constants';
import enMessages from './en.json';
import esMessages from './es.json';
import frMessages from './fr.json';
import plMessages from './pl.json';

export type DashboardMessages = typeof enMessages;

export const messages: Record<Language, DashboardMessages> = {
  EN: enMessages,
  ES: esMessages,
  FR: frMessages,
  PL: plMessages,
};

export const useTypedIntl = useTypedIntlFactory<keyof DashboardMessages>();
export const TypedFormattedMessage = TypedFormattedMessageFactory<keyof DashboardMessages>();
export type TypedIntlShape = ReturnType<typeof useTypedIntl>;
